<template>
    <nav class="pager-wrap" :class="paginationConf.className">
        <ul class="pager" v-if="pages > 1">
            <li v-if="paginationConf.currentNo > 1">
                <a href="javascript:void(0);" @click="prevPage()"
                   class="fa fa-caret-left"
                   style="padding-right: 20px;"></a></li>
            <li style="padding-left:10px;padding-right:10px;"> {{currentNo}} / {{pages}} </li>
            <li v-if="currentNo < pages"><a href="javascript:void(0);" @click="nextPage()" class="fa fa-caret-right"></a></li>
            <li><input type="text" v-model="gopage" class="form-control" data-role="gopage" /></li>
            <li><a href="javascript:void(0);" @click="go()">跳转</a></li>
        </ul>
    </nav>
    <!--<ul class="pagination" v-show="paginationConf.totalRecords > 0">
        <li :class="{disabled: paginationConf.currentNo == 1}" @click="changeCurrentPage(1)">
            <a href="javascript:void(0);">首页</a>
        </li>
        <li :class="{disabled: paginationConf.currentNo == 1}" @click="prevPage()">
            <a href="javascript:void(0);"><i class="fa fa-angle-left"></i></a>
        </li>
        <li>
            {{paginationConf.currentNo}}/{{paginationConf.totalPages}}
        </li>
        <li v-for="item in pageList" track-by="$index" :class="{active: item == paginationConf.currentNo}" @click="changeCurrentPage(item)">
            <a href="javascript:void(0);">{{item}}</a>
        </li>
        <li :class="{disabled: paginationConf.currentNo == paginationConf.totalPages}" @click="nextPage()">
            <a href="javascript:void(0);">
                <i class="fa fa-angle-right"></i>
            </a>
        </li>
        <li :class="{disabled: paginationConf.currentNo == paginationConf.totalPages}" @click="changeCurrentPage(paginationConf.totalPages)">
            <a href="javascript:void(0);">末页</a>
        </li>
    </ul>-->
</template>
<script>

import $ from 'jquery';

export default {
    name: 'Pagination',
    props: {
      'paginationConf': {
        type: Object,
        default: function() {
          return {
            currentNo:1,
            totalRecords:0,
            totalPages: 0,
            className: 'top-line right'
          }
        }
      }
    },
    data: function(){
        return {
            gopage: '',
            pageList: [],
            currentNo: 1,
            pages: 0
        }
    },
    created: function(){
        var _this = this;
        this.paginationConf.showNum = parseInt(this.paginationConf.showNum) ? parseInt(this.paginationConf.showNum) : 9;
        if (this.paginationConf.showNum % 2 === 0) {
            this.paginationConf.showNum = this.paginationConf.showNum - 1;
        }
        if (!this.paginationConf.perPageOptions) {
            this.paginationConf.perPageOptions = [10, 15, 20, 30, 50];
        }
    },
    methods: {
        go: function(){

            var gp = parseInt(this.gopage);
            if(gp && gp > 0 && gp <= this.pages) {
                this.paginationConf.currentNo = this.gopage;
            }
        },
        changeCurrentPage: function(item) {
            this.paginationConf.currentNo = item;
        },
        prevPage: function() {
            if (this.paginationConf.currentNo > 1) {
                this.paginationConf.currentNo -= 1;
            }
        },
        nextPage: function() {
            if (this.paginationConf.currentNo < this.paginationConf.totalPages) {
                this.paginationConf.currentNo += 1;
            }
        },
        getPagination: function(newValue, oldValue) {
            var _this = this;
            _this.paginationConf.currentNo = parseInt(_this.paginationConf.currentNo) ? parseInt(_this.paginationConf.currentNo) : 1;
            _this.paginationConf.totalRecords = parseInt(_this.paginationConf.totalRecords) ? parseInt(_this.paginationConf.totalRecords) : 0;
            _this.paginationConf.pageSize = parseInt(_this.paginationConf.pageSize) ? parseInt(_this.paginationConf.pageSize) : 8;
            _this.paginationConf.totalPages = Math.ceil(_this.paginationConf.totalRecords / _this.paginationConf.pageSize);
            if (_this.paginationConf.currentNo < 1) {
                _this.paginationConf.currentNo = 1;
            }
            if (_this.paginationConf.totalPages > 0 && _this.paginationConf.currentNo > _this.paginationConf.totalPages) {
                _this.paginationConf.currentNo = _this.paginationConf.totalPages;
            }
            _this.pageList = [];
            if (_this.paginationConf.totalPages <= _this.paginationConf.showNum) {
                for (var i = 1; i <= _this.paginationConf.totalPages; i++) {
                    _this.pageList.push(i);
                }
            } else {
                var offset = (_this.paginationConf.showNum + 1) / 2;
                if (_this.paginationConf.currentNo <= offset) {
                    for (var i = 1; i <= _this.paginationConf.showNum; i++) {
                        _this.pageList.push(i);
                    }
                } else if (_this.paginationConf.currentNo > _this.paginationConf.totalPages - offset) {
                    for (var i = _this.paginationConf.showNum - 1; i > 0; i--) {
                        _this.pageList.push(_this.paginationConf.totalPages - i);
                    }
                    _this.pageList.push(_this.paginationConf.totalPages)
                } else {
                    for (var i = Math.ceil(_this.paginationConf.showNum / 2); i > 1; i--) {
                        _this.pageList.push(_this.paginationConf.currentNo - i + 1);
                    }
                    _this.pageList.push(_this.paginationConf.currentNo);
                    for (var i = 1; i < Math.ceil(_this.paginationConf.showNum / 2); i++) {
                        _this.pageList.push(_this.paginationConf.currentNo + i);
                    }
                }
            }

            this.currentNo = this.paginationConf.currentNo;
            this.pages = this.paginationConf.totalPages;
        }
    },
    mounted: function(){
        this.getPagination();//调用为了解决还未被监听（watch）就已经改变。

        var self = this;

        $(this.$el).on('keyup', '[data-role=gopage]', function () {
            var val = $(this).val();
            var v = parseInt(val);

            if(val != v && v > 0) {
                self.gopage = v;
            } else if(!v) {
                self.gopage = 1;
            }
        });
    },
    watch: {
        'paginationConf': {
            handler: function(val){
                this.getPagination();
            },
            deep: true
        },
        'paginationConf.currentNo': {
            handler: function(val){
                this.paginationConf.onChange();
            }
        }/*,
        'gopage': function (val) {

            var v = parseInt(val);
            if(val != v && v > 0) {
                this.gopage = v;
            } else {
                this.gopage = 1;
            }
        }*/
    }
}
</script>
